export type Translations = typeof translations.en;
export type Language = 'ru' | 'en';
export const translations = {
  en: {
    title: 'MEPhIST Tokamak',
    email: 'tokamak@mephi.ru',
    email_subject: 'Access Request to the Portal',
    email_subject2: 'Request access to the portal or a commercial offer',
    email_body: 'Dear staff of the MEPhIST tokamak laboratory!\nI am writing to request access to the remote operation web portal of the MEPHIST-0 tokamak for myself, (Full name), (position/academic status) from (Affiliation), for the following purposes:',    toggle_language: 'Русский',
    hero_title: 'Your Gateway to Hands-On Fusion Research',
    hero_subtitle: 'Remote lab platform & turnkey educational tokamak',
    hero_cta: 'Make a request',

    direction_turnkey_desc: 'We deliver a complete educational tokamak system – from vacuum vessel to control software – ready to operate at your university.',

    experience_items: [
      'We have experience in full-cycle production of small educational tokamaks',
      'All components are easy to maintain and modify. The installation is designed for high fault tolerance with involvement of low-qualified personnel',
      'Your students participate in assembly, configuration, and experiments. Together with the tokamak, you receive trained personnel',
      'Multiphysics device – practice in plasma physics, laser physics, material science, automation',
      'Together with the tokamak, you receive lifetime collaboration with NRNU MEPhI in fusion research'
    ],

    control_title: 'Basic Offer',
    control_desc: 'Turnkey tokamak with vacuum pumping, electromagnetic system based on capacitor power supply, basic diagnostics and IT infrastructure',
    control_features: [
      'Automatic pumping, capacitor charging, discharge initiation from remote control room',
      'Ohmic plasma heating',
      'Plasma research using Rogowski coils, magnetic probes, loop voltage probes, diamagnetic loops, H-alpha detectors and optical spectrometers',
      'Pre-calculated reliable discharge scenarios on protium and helium in limiter configuration',
      'Data archiving in HDF5 file storage and relational database',
      'Local computing cluster with CI/CD, version control systems, cloud storage',
      'Web interfaces for control and analysis',
      'Detailed documentation and remote technical support'
    ],

    optional_title: 'Beyond Ohmic Heating – Optional Systems',
    optional_items: [
      { name: 'HF antennas', desc: 'Ion Cyclotron Resonance Heating' },
      { name: 'Gyrotrons', desc: 'Electron Cyclotron Resonance Heating' },
      { name: 'Neutral Beam Injector', desc: 'Heating and current drive studies' }
    ],

    education_title: 'Invest in Knowledge – Two-Year Educational Program',
    education_desc: 'We train your students within the Master\'s program of NRNU MEPhI in "High-tech Plasma and Energy Installations"',
    education_features: [
      'Practical course for groups up to 15 people',
      'Master\'s theses based on experiments',
      'Integration into the global scientific community',
      'Trained personnel to work on your installation!'
    ],

    cta_title: 'Ready to Start?',
    cta_text: 'Contact us to get free demo access or discuss a turnkey solution.',
    cta_button: 'Send Email',
    nav_online: 'Online Platform',
    nav_turnkey: 'Turnkey Tokamak',
    nav_diagnostics: 'Diagnostics',
    nav_publications: 'Publications',

    modal_access_title: 'Request Free Access to Online Platform or Commercial Offer',
    modal_access_text: 'Please send a free-form request to our email:',
    modal_order_title: 'Order a Plasma Shot',
    modal_order_text: 'To place an order, describe your requirements and send them to:',
    modal_close: 'Close',

    video_caption: 'Discharge Video',
    graph_caption: 'Oscillograms with Main Diagnostics for shot ',
    tokamak_description: 'MEPhIST is a series of educational and research small spherical tokamaks (R = 25 cm, a = 13 cm) operating at the Plasma Physics Department of NRNU MEPhI. The tokamaks implement basic discharges on H and He in limiter configuration with toroidal field on axis 120 mT, microwave pre-ionization and ohmic plasma heating. Typical discharge duration on protium is 10 ms, plasma current up to 15 kA, electron temperature up to 300 eV, linearized electron density around 10¹⁸ m⁻².',
    diagnostics_full_list: [
      'Loop voltage probes',
      'Magnetic probes',
      'Diamagnetic loops',
      'Rogowski coils',
      'Microwave and IR interferometers',
      'Optical and mass spectrometers',
      'H-alpha diagnostics',
      'Forward/reflected microwave and RF power measurement',
      'AXUV bolometers',
      'X-ray spectrometer',
      'Material science probe',
      'Fast camera',
      'Langmuir probes (triple probe)',
      'Vacuum gauges'
    ],

      
    diagnostics: [
      { // 0. Rogowski coils
        title: 'Rogowski coils',
        description: [
          'Current measurement in all magnetic coils',
          'Rogowski coil inside the vacuum vessel for plasma current determination.',
          'Determination of ohmic heating power, plasma conductivity'
        ],
        chips: ['100 kHz', '14 bit', '±10 V', 'LCard LTR11']
      },
      { // 1. Loop voltage
        title: 'Loop voltage',
        description: [
          '16 single-turn loop voltage coils outside the vacuum vessel and 5 inside.',
          'Determination of ohmic heating power, plasma energy balance, magnetic equilibrium reconstruction.'
        ],
        chips: ['100 kHz', '14 bit', '±10 V', 'LCard LTR11']
      },
      { // 2. Diamagnetic loops
        title: 'Diamagnetic loops',
        description: [
          '2 diamagnetic loops inside the vessel.',
          'Determination of toroidal field flux variation.'
        ],
        chips: ['100 kHz', '14 bit', '±10 V', 'LCard LTR11']
      },
      { // 3. Magnetic probes
        title: 'Magnetic probes',
        description: [
          '4 magnetic probes inside the vacuum vessel.',
          'Plasma position determination, position control (planned).'
        ],
        chips: ['10 MHz', '14 bit', '±10 V', 'LCard LTR210']
      },
      { // 4. RF power
        title: 'RF power',
        description: [
          'Measurement of forward and reflected microwave and RF power for preionization and heating efficiency determination.'
        ],
        chips: ['100 kHz', '14 bit', '±10 V', 'LCard LTR11']
      },
      { // 5. Microwave and IR interferometers
        title: 'Microwave and IR interferometers',
        description: [
          'Line-integrated electron density measurement.',
          'Microwave at 94 GHz. Critical density n<sub>c</sub> = 1.2×10<sup>14</sup> cm<sup>−3</sup>.',
          'IR based on CO<sub>2</sub> laser 10 μm.'
        ],
        chips: ['10 MHz', '14 bit', '±10 V', 'LCard LTR210']
      },
      { // 6. H-alpha
        title: 'H-alpha',
        description: [
          'Emission measurement using PIN photodiode with filter at 656 nm (FWHM 7 nm).'
        ],
        chips: ['10 MHz', '14 bit', '±10 V', 'LCard LTR210']
      },
      { // 7. Optical spectrometer
        title: 'Optical spectrometer',
        description: [
          'OceanFX spectrometer 300–1000 nm, slit 10 μm, integration time from 100 μs',
          'Measurement of time-integrated visible spectrum.',
          'Impurity identification.'
        ],
        chips: ['digital', '16 bit', '3048 pixels']
      },
      { // 8. X-ray spectrometer
        title: 'X-ray spectrometer',
        description: [
          'Detector array based on PMT-67 and organic scintillators.',
          'Electron temperature determination.'
        ],
        chips: ['100 kHz', '16 bit', '±10 V', 'AD7606']
      },
      { // 9. AXUV bolometers
        title: 'AXUV bolometers',
        description: [
          '32 AXUV detectors inside pinhole camera.',
          'Plasma radiation profile measurement.'
        ],
        chips: ['125 kHz', '16 bit', '±10 V', 'LCARD E-502']
      },
      { // 10. Fast camera
        title: 'Fast camera',
        description: [
          'Visual observation.',
          'Ximea camera.'
        ],
        chips: []
      },
      { // 11. Material probe
        title: 'Material probe',
        description: [
          'Installation of exchangeable heads in a differentially pumped port permanently connected to the discharge chamber.',
          'Sample exposure, stray field measurement by electron beam, probe diagnostics.'
        ],
        chips: []
      },
      { // 12. Langmuir probes, triple probe
        title: 'Langmuir probes, triple probe',
        description: [
          'Measurement of edge plasma temperature and density, and their radial profiles.'
        ],
        chips: ['100 kHz', '16 bit', '±10 V', 'AD7606']
      },
      { // 13. Vacuum
        title: 'Vacuum',
        description: [
          'Residual pressure measurement with Pfeiffer, Thyracont wide-range gauges.',
          'Gas flow measurement with Bronkhorst, MKS controllers.',
          'Absolute working gas pressure measurement with Pfeiffer capacitive vacuum gauges.',
          'Residual gas analyzer Extorr XT200.'
        ],
        chips: []
      }
    ],

// Блок "Любая ваша диагностика"
any_diagnostic_title: 'Any custom diagnostic',
any_diagnostic_subtitle: 'We can integrate your diagnostic equipment',

    online_services: [
      { name: 'Plasma Shot Ordering', desc: 'Submit requests for discharges with custom parameters.' },
      { name: 'Data Visualization', desc: 'Interactive plots of plasma current, density, fields, spectra.' },
      { name: 'Metadata Table', desc: 'Browse all shots with filtering and search.' },
      { name: 'Online Learning', desc: 'Interactive courses in plasma physics and fusion experiment techniques with lectures, tests, and practical sessions.' },
      { name: 'Online Tokamak Data Processing', desc: 'Python web environment for data analysis, as well as repositories for remote connection to tokamak database.' },
      { name: 'Knowledge Base & Git', desc: 'Local wiki and version control system with codebase.' }
    ],
    order_block_title: 'Order a Plasma Shot',
    order_block_desc: 'Submit a request for a discharge with required parameters.',
    gas_type_label: 'Gas Type',
    pressure_label: 'Pressure',
    magnetic_field_label: 'Toroidal Field',
    inductor_label: 'Loop Voltage',
    notes_label: 'Notes',
    user_name_label: 'Your Name',
    select_gas_type: 'Select Gas',
    add_order: 'Add Order',
    click_to_select_files: 'Upload discharge scenario',
    files_attached: 'files attached',
    order_modal_title: 'Request Demo Access',
    order_modal_text: 'To place an order, send a free-form access request to our email:',
    nav_description: 'Description',
    nav_parameters: 'Parameters',

    section_description: 'About MEPhIST Tokamak',
    section_parameters: 'Plasma Shot Examples',
    section_diagnostics: 'Diagnostics',
    section_online: 'Remote Online Lab Platform',
    section_turnkey: 'Turnkey Tokamak for Your University',
    section_publications: 'Related Publications',
    enter_platform: 'Log In to Portal',
    nav_contacts: 'Contacts',
    online_platform_descr: 'Full access to real-time experimental data, data analysis tools and ordering plasma shots with specific parameters. Online learning services in plasma physics and fusion experiment techniques, local knowledge base and code repositories. Conducting remote workshops based on NRNU MEPhI video conferencing system',
    workshop_descr: 'At your request, we can conduct a remote workshop with your students. During the workshop, our lectors will give a short lecture on tokamak physics, introduce our platform, and propose a mini-study on one of the topics below. Your students will be able to create a plasma scenario and conduct data analysis using our remote online platform. Following the workshop, they may present at a conference and publish papers based on the experimental data.',
    
    // Table headers
    table_id: 'ID',
    table_time: 'Time',
    table_gas: 'Gas',
    table_pressure: 'Pressure, mPa',
    table_bphi: 'Bφ, mT',
    table_ip: 'Ip, kA',
    table_ne: 'nₑ, m⁻²',
    table_plasma: 'Plasma',
    table_comment: 'Comment',
    
    // Key features section
    key_features_title: 'Key Features:',
    key_feature_items: [
      'First and only educational tokamak in Russia with high degree of production localization',
      'Installation fully integrated into Russian national platform for collaborative fusion research <a href="https://fusionspace.ru" target="_blank">fusionspace.ru</a>.',
      'The MEPhIST tokamak series concept is available for deployment both at the NRNU MEPhI and on request at other universities in Russia and abroad.',
      'Flexible scientific agenda (test your discharge scenarios, diagnostics, any plasma-facing component concepts).',
      'Lab multiphysics: plasma physics, lasers, high-temperature superconductivity, high-current electronics and material science with involvement of specialized experts from MEPhI departments and Russian research institutes.',
      'A fully functional online platform <a href="https://tokamak.mephi.ru/orders" target="_blank">tokamak.mephi.ru</a> for education, ordering plasma shots,  simulation and analyzing experimental data.',
      'Regular lab sessions and workshops for students from around the world.',
      'Bachelor, Master thesis and PhD dissertation preparation within NRNU MEPhI educational programs.'
    ],
    
    // Contacts section
    contacts_title: 'Contacts',
    contacts_email: 'Email',
    contacts_phone: 'Phone',
    contacts_telegram: 'Telegram',
    contacts_mephi: 'MEPhI',
    contacts_admission: ' Academic Programs',
    contacts_license: 'Data License',
    
    // Footer
    footer_text: '© {year} MEPhIST-0 Remote Lab Platform',
    
    // Units
    unit_mpa: 'mPa',
    unit_mt: 'mT',
    unit_v: 'V',

    // Workshop topics
    workshop_title: 'Workshop Topics',
    workshop_items: [
      'Ohmic heating power. Spitzer formula',
      'Kruskal-Shafranov criterion at the boundary (plasma MHD activity)',
      'Edge plasma measurements with Langmuir probes',
      'Plasma density measurements using microwave interferometer',
      'Plasma energy content',
      'Or any your scientific agenda'
    ],

    // Image descriptions
    img_tokamak2: 'MEPhIST-0 Tokamak Overview',
    img_control_room: 'Control Room',
    img_capacitor: 'Capacitor Bank',
    img_graph: 'Oscillograms with Main Diagnostics',
    img_turnkey: 'Turnkey Tokamak for your University',
    img_shots_table: 'Shots Metadata Table',
    img_moodle: 'Learning Platform',
    img_control_panel: 'Control Panel Interface',
    shots_vis: 'shots visualizer',

    drawer_menu_title: 'Menu',
    modal_access_license_before: 'Use of experimental data from MEPhIST-0 tokamak is governed by ',
    modal_access_license_link: 'license agreement',
    image_zoom_text: 'Zoom In',
    close: 'Close',
    shots_table_caption: 'Example shots on MEPhIST-0 tokamak',
    workshop_poster_alt: 'Workshop poster',
    workshop_poster_caption: 'Example of workshop results',
    turnkey_slideshow: {
      turnkey_title: 'MEPhIST-1 Concept',
      mephist0_title: 'MEPhIST-0',
      server_title: 'Server Rack',
      server_desc: 'Control, storage and microservices deployment rack',
      charger_title: 'Charging Rack',
      charger_desc: 'Capacitor bank charging control rack',
      capacitors_title: 'Capacitor Bank',
      capacitors_desc: 'Capacitor bank for electromagnetic coil power supply',
      vacuum_title: 'Vacuum System',
      vacuum_desc: 'Pumping and vacuum maintenance system for the vacuum chamber',
      daq_title: 'DAQ Rack',
      daq_desc: 'Primary data acquisition rack from diagnostics',
      },
      select_shot_prompt: 'Choose shot',
      qr_code_alt: "Link to tokamak.mephi.ru",
      // Подписи осей графиков
      graph_xaxis_time: 'Time (ms)',
      graph_yaxis_ip: 'Ip (kA)',
      graph_yaxis_vl: 'VL (V)',
      graph_yaxis_norm_intensity: 'Norm. intensity',
      graph_yaxis_density: 'Electron linearized density',
      graph_yaxis_density_product: 'Nₑ·l (10¹⁸ m⁻²)',
      graph_yaxis_ics: 'I CS (kA)',
      graph_yaxis_ipf: 'I PF (kA)',
      graph_yaxis_bphi: 'B (mT)',
      // Легенды графиков
      graph_legend_ip: 'Ip',
      graph_legend_vl_avg: 'VL avg',
      graph_legend_halpha: 'H-α',
      graph_legend_ciii: 'CIII',
      graph_legend_axuv: 'AXUV',
      graph_legend_density: 'Electron linearized density',
      graph_legend_cs: 'CS',
      graph_legend_pf12: 'PF1/2',
      graph_legend_pf34_x3: 'PF3/4 x3',
      graph_legend_bphi: 'Bφ',
      tooltip_see_shot: 'See shot',
      to_top: 'To top',
      ext_num: '+7 (495) 788 56 99 ext. 9768',
      brochure: 'get brochure',
  
  },
  ru: {
    title: 'Токамак МИФИСТ',
    email: 'tokamak@mephi.ru',
    email_subject: 'Получение доступа к порталу',
    email_subject2: 'Запрос доступа к порталу или коммерческого предложения',
    email_body: 'Уважаемые сотрудники лаборатории токамака МИФИСТ!\nПрошу предоставить доступ к веб порталу токамака МИФИСТ-0 мне, (ФИО), (должность/академический статус) из организации (Аффилиация) для следующих целей:',
    toggle_language: 'English',
    hero_title: 'Ваш путь к практическим исследованиям термоядерного синтеза',
    hero_subtitle: 'Веб портал удалённых работ и учебный токамак «под ключ»',
    hero_cta: 'Сделать запрос',

    direction_turnkey_desc: 'Мы можем произвести полностью готовую к работе установку – от систем питания и вакуумной камеры до систем автоматизированного управления и сопутствующей IT инфраструктуры – для работы в вашем университете.',

    experience_items: [
      'У нас имеется опыт полноциклового производства учебных токамаков малого размера',
      'Все компоненты легко обслуживать и модифицировать. Установка изначально спроектирована в расчёте на высокую отказоустойчивость в условиях вовлечения заведомо низкоквалифицированных кадров',
      'Ваши студенты участвуют в сборке, настройке и экспериментах. Вместе с токамаком вы получаете обученный персонал',
      'Мультифизичная установка – практика в физике плазмы, лазерной физике, материаловедении, автоматизации',
      'Вместе с токамаком вы получаете пожизненное сотрудничество с НИЯУ МИФИ в области термоядерных исследований'
    ],

    control_title: 'Базовое предложение',
    control_desc: 'Токамак под ключ с вакуумной откачкой, электромагнитной системой на базе конденсаторного питания, базовыми диагностиками и IT инфраструктурой',
    control_features: [
      'Автоматическая откачка, заряд конденсаторов, запуск разряда из удалённой пультовой',
      'Омический нагрев плазмы',
      'Исследование плазмы с помощью поясов Роговского, магнитных зондов, петель напряжения обхода, диамагнитных петель, H-alpha детекторов и оптических спектрометров',
      'Заранее рассчитанные надёжные сценарии разряда на протии и гелии в лимитерной конфигурации',
      'Архивация данных в файловое HDF5 хранилище и реляционную базу данных. Пультовая и графические интерфейсы для управления и анализа',
      'Локальный вычислительный кластер с CI/CD, системами контроля версий, облачным хранилищем',
      'Подробная документация и техническая поддержка'
    ],

    optional_title: 'Опция - За пределами омического нагрева',
    optional_items: [
      { name: 'ВЧ антенны', desc: 'Ионно-циклотронный нагрев' },
      { name: 'Гиротроны', desc: 'Электронно-циклотронный нагрев' },
      { name: 'Инжектор нейтральных атомов', desc: 'Исследования нагрева и поддержания тока' }
    ],

    education_title: 'Инвестируйте в знания – двухгодичная образовательная программа',
    education_desc: 'Мы обучаем ваших студентов в рамках программы магистратуры НИЯУ МИФИ по направлению "Высокотехнологические плазменные и энергетические установки" и вместе с ними собираем для вас токамак.',
    education_features: [
      'Практический курс для групп до 15 человек',
      'Магистерские диссертации на основе экспериментов',
      'Интеграция в мировое научное сообщество',
      'Обученный персонал для работы на вашей установке!'
    ],

    cta_title: 'Готовы начать?',
    cta_text: 'Свяжитесь с нами, чтобы получить бесплатный демо-доступ или обсудить решение «под ключ».',
    cta_button: 'Написать письмо',
    nav_online: 'Веб портал',
    nav_turnkey: 'Токамак под ключ',
    nav_diagnostics: 'Диагностики',
    nav_publications: 'Статьи',

    modal_access_title: 'Запросить бесплатный доступ к порталу или получить коммерческое предложение',
    modal_access_text: 'Пожалуйста, отправьте запрос в свободной форме на нашу почту:',
    modal_order_title: 'Заказать плазменный импульс',
    modal_order_text: 'Чтобы сделать заказ, опишите ваши требования и отправьте их на адрес:',
    modal_close: 'Закрыть',

    video_caption: 'Видео разряда',
    graph_caption: 'Осциллограммы с основными диагностиками для импульса',
    tokamak_description: 'МИФИСТ – серия учебно-исследовательских малых сферических (R = 25 см, a = 13 см) токамаков, функционирующих на кафедре физики плазмы университета НИЯУ МИФИ. На токамаках реализованы разряды на H, He и Ar в лимитерной конфигурации при тороидальном магнитном поле на оси 120 мТл, СВЧ предыонизации и омическом нагреве плазмы. Характерная длительность разряда на H 10 мс, ток плазмы до 15 кА, температура электронов до 300 эВ, линеаризованная плотность электронов порядка 10¹⁸ м⁻².',
    
    diagnostics_full_list: [
      'Петли измерения напряжения на обходе',
      'Магнитные зонды',
      'Диамагнитные петли',
      'Пояса Роговского',
      'СВЧ и ИК интерферометры',
      'Оптические и масс-спектрометры',
      'H-alpha диагностика',
      'Измерение мощности СВЧ и ВЧ нагрева',
      'Болометры AXUV',
      'Рентгеновский спектрометр',
      'Материаловедческий зонд',
      'Быстрая камера',
      'Зонды Ленгмюра, тройной зонд',
      'Вакуумметрия'
    ],

    diagnostics: [
      { // 0. Пояса Роговского
        title: 'Пояса Роговского',
        description: [
          'Измерение токов по всем магнитным катушкам',
          'пояс Роговского внутри вакуумной камеры для определения тока плазмы.',
          'Определение мощности омического нагрева, проводимости плазмы'
        ],
        chips: ['100 кГц', '14 бит', '±10 В', 'LCard LTR11']
      },
      { // 1. Петли напряжения на обходе
        title: 'Петли напряжения на обходе',
        description: [
          '16 одновитковых петель напряжения обхода снаружи вакуумной камеры и 5 внутри.',
          'Определение мощности омического нагрева, проводимости плазмы, восстановление магнитного равновесия.'
        ],
        chips: ['100 кГц', '14 бит', '±10 В', 'LCard LTR11']
      },
      { // 2. Диамагнитные петли
        title: 'Диамагнитные петли',
        description: [
          '2 диамагнитные петли внутри камеры.',
          'Определение изменения потока тороидального поля.'
        ],
        chips: ['100 кГц', '14 бит', '±10 В', 'LCard LTR11']
      },
      { // 3. Магнитные зонды
        title: 'Магнитные зонды',
        description: [
          '4 магнитных зонда внутри вакуумной камеры.',
          'Определение положения плазменного шнура, управление положением (в планах).'
        ],
        chips: ['10 МГц', '14 бит', '±10 В', 'LCard LTR210']
      },
      { // 4. Измерение СВЧ и ВЧ мощности
        title: 'Измерение мощности СВЧ и ВЧ нагрева',
        description: [
          'Измерение прямой и отражённой СВЧ и ВЧ мощности для определения эффективности предыонизации и нагрева.'
        ],
        chips: ['100 кГц', '14 бит', '±10 В', 'LCard LTR11']
      },
      { // 5. СВЧ и ИК интерферометры
        title: 'СВЧ и ИК интерферометры',
        description: [
          'Измерение линеаризованной электронной плотности плазмы.',
          'СВЧ на частоте 94 ГГц. Критическая плотность n<sub>c</sub> = 1,2×10<sup>14</sup> см<sup>−3</sup>.',
          'ИК на базе CO<sub>2</sub> лазера 10 мкм.'
        ],
        chips: ['10 МГц', '14 бит', '±10 В', 'LCard LTR210']
      },
      { // 6. H-alpha
        title: 'H-alpha',
        description: [
          'Измерение излучения с помощью PIN фотодиода с фильтром на длине волны 656 нм (полуширина 7 нм).'
        ],
        chips: ['10 МГц', '14 бит', '±10 В', 'LCard LTR210']
      },
      { // 7. Оптический спектрометр
        title: 'Оптический спектрометр',
        description: [
          'Спектрометр OceanFX 300–1000 нм, щель 10 мкм, время интегрирования от 100 мкс',
          'Измерение интегрального по длительности разряда спектра излучения в видимом диапазоне.',
          'Определение примесей в плазме.'
        ],
        chips: ['цифровой', '16 бит', '3048 пикселей']
      },
      { // 8. Рентгеновский спектрометр
        title: 'Рентгеновский спектрометр',
        description: [
          'Набор датчиков на базе ФЭУ67 и органических сцинтилляторов.',
          'Определение температуры электронов плазмы.'
        ],
        chips: ['100 кГц', '16 бит', '±10 В', 'AD7606']
      },
      { // 9. Болометры AXUV
        title: 'Болометры AXUV',
        description: [
          'Набор 32 датчиков AXUV внутри камеры-обскура.',
          'Определение профиля излучения плазмы.'
        ],
        chips: ['125 кГц', '16 бит', '±10 В', 'LCARD E-502']
      },
      { // 10. Быстрая камера
        title: 'Быстрая камера',
        description: [
          'Визуальное наблюдение.',
          'Камера Ximea.'
        ],
        chips: [] // нет чипсов
      },
      { // 11. Материаловедческий зонд
        title: 'Материаловедческий зонд',
        description: [
          'Установка сменных головок в постоянно подключенном к разрядной камере дифференциально откачиваемом шлюзе.',
          'Экспонирование образцов, измерение рассеянных полей электронным пучком, зондовые диагностики.'
        ],
        chips: []
      },
      { // 12. Зонды Ленгмюра
        title: 'Зонды Ленгмюра, тройной зонд',
        description: [
          'Определение температуры и плотности пристеночной плазмы, а также их профилей по радиусу.'
        ],
        chips: ['100 кГц', '16 бит', '±10 В', 'AD7606']
      },
      { // 13. Вакуумметрия
        title: 'Вакуумметрия',
        description: [
          'Измерение остаточного давления широкодиапазонными датчиками Pfeiffer, Thyracont.',
          'Измерение потока напускаемого газа датчиками Bronkhorst, MKS.',
          'Измерение абсолютного давления рабочего газа емкостными вакуумметрами Pfeiffer.',
          'Анализатор остаточных газов Extorr XT200.'
        ],
        chips: []
      }
    ],

    // Ключи для блока "Любая ваша диагностика"
    any_diagnostic_title: 'Любая ваша диагностика',
    any_diagnostic_subtitle: 'Мы можем испытать ваше диагностическое оборудование',

    online_services: [
      { name: 'Заказ плазменных импульсов', desc: 'Подача заявок на разряды с настраиваемыми параметрами.' },
      { name: 'Визуализация данных', desc: 'Интерактивные графики тока, плотности плазмы, полей, спектров.' },
      { name: 'Таблица метаданных', desc: 'Просмотр всех импульсов с фильтрацией и поиском.' },
      { name: 'Потоковый видеостримминг', desc: 'Онлайн трансляция из экспериментального зала лаборатории и панели управления в пультовой' },
      { name: 'Онлайн обучение', desc: 'Интерактивные курсы в области физики плазмы и техники термоядерного эксперимента с лекциями, тестами, и практическими занятиями.' },
      { name: 'Онлайн обработка данных с токамака', desc: 'Веб среда Python для анализа данных, а также репозитории для удалённого подключения к базе данных токамака.' },
      { name: 'База знаний и Git', desc: 'Локальная вики и система контроля версий с кодовой базой.' }
    ],
    order_block_title: 'Заказ плазменного импульса',
    order_block_desc: 'Отправьте заявку на проведение разряда с нужными параметрами.',
    gas_type_label: 'Тип газа',
    pressure_label: 'Давление',
    magnetic_field_label: 'Тороидальное поле',
    inductor_label: 'Напряжение на обходе',
    notes_label: 'Примечания',
    user_name_label: 'Ваше имя',
    select_gas_type: 'Выберите газ',
    add_order: 'Добавить заказ',
    click_to_select_files: 'Загрузите сценарий разряда',
    files_attached: 'файлов прикреплено',
    order_modal_title: 'Запросить доступ к веб-порталу',
    order_modal_text: 'Чтобы сделать заказ, отправьте запрос на доступ к порталу в свободной форме на нашу почту:',
    nav_description: 'Описание',
    nav_parameters: 'Параметры',

    section_description: 'О токамаке МИФИСТ',
    section_parameters: 'Примеры импульсов плазмы',
    section_diagnostics: 'Диагностики',
    section_online: 'Веб портал удалённых работ',
    section_turnkey: 'Токамак под ключ для вашего университета',
    section_publications: 'Основные научные публикации',
    enter_platform: 'Войти на портал',
    nav_contacts: 'Контакты',
    online_platform_descr: 'Полный доступ к данным экспериментов в реальном времени, инструментам анализа данных и заказу плазменных импульсов с определёнными параметрами. Сервисы онлайн обучения в области физики плазмы и техники термоядерного эксперимента, локальные база знаний и кодовые базы. Проведение удалённых воркшопов на базе системы видеоконференцсвязи НИЯУ МИФИ',
    workshop_descr: 'По вашей заявке возможно проведение  удалённого воркшопа с вашими студентами. В ходе воркшопа наши преподаватели проведут короткую лекцию по физике токамаков, расскажут о нашей платформе и предложат мини исследование на одну из приведённых ниже тем. Ваши студенты смогут сами задать сценарий разряда и провести анализ данных и использованием нашей удалённой онлайн платформы. По результатам воркшопа возможно выступление на конференциях и публикаций совместных статей по полученным экспериментальным данным.',
    // Table headers
    table_id: 'ID',
    table_time: 'Время',
    table_gas: 'Газ',
    table_pressure: 'Давление, мПа',
    table_bphi: 'Bφ, мТл',
    table_ip: 'Ip, кА',
    table_ne: 'nₑ, м⁻²',
    table_plasma: 'Плазма',
    table_comment: 'Комментарий',
    
    // Key features section
    key_features_title: 'Ключевые особенности:',
    key_feature_items: [
      'Первый и единственный учебный токамак в России, изготовленный с высокой степенью локализации производства.',
      'Установка полностью интегрирована в Российскую национальную платформу для совместных исследований в области управляемого термоядерного синтеза <a href="https://fusionspace.ru" target="_blank">fusionspace.ru</a>.',
      'Наличие концепта серии токамаков МИФИСТ для развёртывания как на площадке университета НИЯУ МИФИ, так и под заказ в других ВУЗах России и зарубежья.',
      'Гибкая научная повестка (возможность испытывать ваши сценарии разряда, диагностики, любые концепции обращённых к плазме элементов).',
      'Мультифизичность лаборатории: физика плазмы, лазеров, высокотемпературная сверхпроводимость, сильноточная электроника и материаловедение с вовлечением профильных специалистов с дружественных кафедр МИФИ и НИИ России.',
      'Полностью функциональная онлайн платформа <a href="https://tokamak.mephi.ru/orders" target="_blank">tokamak.mephi.ru</a> для обучения, заказа импульсов плазмы, моделирования и анализа экспериментальных данных.',
      'Регулярное проведение лабораторных работ и организация воркшопов для студентов со всего мира.',
      'Подготовка дипломных работ студентов бакалавриата, магистратуры и кандидатских диссертаций в рамках программ обучения НИЯУ МИФИ.'
    ],
    
    // Contacts section
    contacts_title: 'Контакты',
    contacts_email: 'Почта',
    contacts_phone: 'Телефон',
    contacts_telegram: 'Телеграм',
    contacts_mephi: 'сайт МИФИ',
    contacts_admission: 'Программы обучения',
    contacts_license: 'Лицензия на данные',
    
    // Footer
    footer_text: '© {year} Портал удалённых работ на токамаке МИФИСТ',
    
    // Units
    unit_mpa: 'мПа',
    unit_mt: 'мТ',
    unit_v: 'В',

    // Workshop topics
    workshop_title: 'Лабораторные работы и воркшопы',
    workshop_items: [
      'Омическая мощность нагрева. Формула Спитцера',
      'Критерий Крускала-Шафранова на границе (МГД активность плазмы)',
      'Измерение пристеночной плазмы зондами Ленгмюра',
      'Измерение плотности плазмы с помощью СВЧ интерферометра',
      'Энергосодержание плазмы',
      'Или любая ваша научная повестка'
    ],

    // Image descriptions
    img_tokamak2: 'Общий вид на токамак МИФИСТ-0',
    img_control_room: 'Пультовая',
    img_capacitor: 'Конденсаторная батарея',
    img_graph: 'Осциллограммы тока плазмы и напряжения обхода',
    img_turnkey: 'Концепт токамака МИФИСТ-1',
    img_shots_table: 'Таблица метаданных импульсов',
    img_moodle: 'Образовательная платформа',
    img_control_panel: 'Интерфейс панели управления',
    shots_vis: 'Интерфейс витрины данных',

    // New keys for direct strings
    drawer_menu_title: 'Меню',
    modal_access_license_before: 'Использование экспериментальных данных с токамака МИФИСТ-0 регламентируется ',
    modal_access_license_link: 'лицензионным договором',
    image_zoom_text: 'Увеличить',
    close: 'Закрыть',
    shots_table_caption: 'Пример разрядов на токамаке МИФИСТ-0',
    workshop_poster_alt: 'Постер на конференции в Чили',
    workshop_poster_caption: 'Пример результатов воркшопа',
    turnkey_slideshow: {
        turnkey_title: 'Концепт МИФИСТ-1',
        mephist0_title: 'МИФИСТ-0',
        server_title: 'Серверная стойка',
        server_desc: 'Стойка управления, хранения и развёртывания микросервисов',
        charger_title: 'Стойка зарядки',
        charger_desc: 'Стойка управления зарядкой конденсаторной батареи',
        capacitors_title: 'Конденсаторная',
        capacitors_desc: 'Батарея конденсаторов для питания электромагнитных катушек',
        vacuum_title: 'Вакуумный пост',
        vacuum_desc: 'Система откачки и поддержания вакуума в вакуумной камере',
        daq_title: 'Стойка DAQ',
        daq_desc: 'Стойка первичного сбора данных с диагностик',
    },
    select_shot_prompt: 'Выберите разряд',
    qr_code_alt: "Ссылка на tokamak.mephi.ru",
    graph_xaxis_time: 'Время (мс)',
    graph_yaxis_ip: 'Ток плазмы (кА)',
    graph_yaxis_vl: 'Напряжение на обходе (В)',
    graph_yaxis_norm_intensity: 'Норм. интенсивность',
    graph_yaxis_density: 'Линеаризованная электронная плотность',
    graph_yaxis_density_product: 'nₑ·l (10¹⁸ м⁻²)',
    graph_yaxis_ics: 'Ток CS (кА)',
    graph_yaxis_ipf: 'Ток PF (кА)',
    graph_yaxis_bphi: 'B (мТл)',
    graph_legend_ip: 'Ip',
    graph_legend_vl_avg: 'VL среднее',
    graph_legend_halpha: 'H-α',
    graph_legend_ciii: 'CIII',
    graph_legend_axuv: 'AXUV',
    graph_legend_density: 'Линеаризованная электронная плотность',
    graph_legend_cs: 'CS',
    graph_legend_pf12: 'PF1/2',
    graph_legend_pf34_x3: 'PF3/4 x3',
    graph_legend_bphi: 'Bφ',
    tooltip_see_shot: 'Открыть импульс',
    to_top: 'Наверх',
    ext_num: '+7 (495) 788 56 99 доб. 9768',
    brochure: 'скачать брошюру',
  },
   
};